// extracted by mini-css-extract-plugin
export default {"pl1":"Spinner_pl1__NzqqM","pl1g":"Spinner_pl1g__6Gtgy","pl1rect":"Spinner_pl1rect__1Kebn","pl1a":"Spinner_pl1a__N8n8M","pl1b":"Spinner_pl1b__rXapJ","pl1c":"Spinner_pl1c__MB3TK"};